import axios from 'axios'
import env from '@/mixins/env'

var authenticationMixin = {
  methods: {
    getTokens (vendorPortal = false) {
      let url = env.api_url() + '/shopify/authenticate-shop/?' + env.params()

      if (vendorPortal) {
        url = env.api_url() + '/vendors/authenticate-vendor/?' + env.params()
      }

      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: url
        }).then((response) => {
          if (response.status === 200) {
            if (response.data.refresh === undefined) {
              resolve(false)
            } else {
              resolve(response.data)
            }
          } else {
            resolve(false)
          }
        }).catch(error => {
          if (error) {
            resolve(false)
          }
        })
      })
    },
    getToken (email, password) {
      return new Promise((resolve, reject) => {
        this.axios({
          method: 'post',
          url: env.api_url() + '/token/',
          data: {
            email: email,
            password: password
          }
        }).then((response) => {
          if (response.status === 200) {
            this.$store.state.refreshToken = response.data.refresh

            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    refreshToken () {
      return new Promise((resolve, reject) => {
        this.axios({
          method: 'post',
          url: env.api_url() + '/token/refresh/',
          data: {
            refresh: this.$store.state.refreshToken
          }
        }).then((response) => {
          if (response.status === 200) {
            let expireTime = new Date()

            expireTime.setMinutes(expireTime.getMinutes() + 5)

            this.$store.state.token = {
              'token': response.data.access,
              'expire': expireTime
            }

            this.$store.state.refreshToken = response.data.refresh

            resolve(response.data.access)
          } else {
            resolve(false)
          }
        })
      })
    },
    sendPhone (phone) {
      return new Promise((resolve, reject) => {
        this.axios({
          method: 'post',
          url: env.api_url() + '/phone-verification/',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            phone: phone
          }
        }).then((response) => {
          if (response.status === 200) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    }
  }
}

export default authenticationMixin



// WEBPACK FOOTER //
// ./src/mixins/authentication.js